import { ManuteRequestConfig } from '@/api/types';
import { PriceListQueryParams, PriceListRequest, ArticlePriceListRequest } from '@/api/requests/article/types';
import { RequestQueryParams } from '../types';

/**
 * Request to find all price lists.
 * @param params
 */
export const ALL = (params?: PriceListQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: '/price-lists',
    params: {
        ...params,
    },
});

/**
 * Request to save a new price list.
 * @param data
 */
export const STORE = (data: PriceListRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: '/price-lists',
    data,
});

/**
 * Request to find a price list by id.
 * @param priceListId
 */
export const FIND = (priceListId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/price-lists/${priceListId}`,
});

/**
 * Request to update an existing price list.
 * @param priceListId
 * @param data
 */
export const UPDATE = (priceListId: number, data: PriceListRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/price-lists/${priceListId}`,
    data,
});

/**
 * Request to delete a price list by id.
 * @param priceListId
 */
export const DELETE = (priceListId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/price-lists/${priceListId}`,
});


/**
 * Request to find all articles of price list.
 * @param params
 * @param priceListId
 */
export const ALLARTICLES = (priceListId: number, params?: RequestQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: `/price-lists/${priceListId}/articles`,
    params: {
        ...params,
    },
});

/**
 * Request to find an article by id.
 * @param priceListId
 * @param articleId
 */
export const FINDARTICLE = (priceListId: number, articleId: number): ManuteRequestConfig => ({
    method: 'GET',
    url: `/price-lists/${priceListId}/articles/${articleId}`,
});

/**
 * Request to save a new article.
 * @param priceListId
 * @param data
 */
export const STOREARTICLE = (priceListId: number, article: ArticlePriceListRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: `/price-lists/${priceListId}/articles`,
    data: article,
});

/**
 * Request to update an existing article.
 * @param priceListId
 * @param articleId
 * @param data
 */
export const UPDATEARTICLE = (priceListId: number, articleId: number, article: ArticlePriceListRequest): ManuteRequestConfig => ({
    method: 'PUT',
    url: `/price-lists/${priceListId}/articles/${articleId}`,
    data: article,
});

/**
 * Request to delete an article by id.
 * @param priceListId
 * @param articleId
 */
export const DELETEARTICLE = (priceListId: number, articleId: number): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `/price-lists/${priceListId}/articles/${articleId}`,
});
